import { useRef, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

export function Honeypot({ value, onChange }) {
  return (
    <div className="hp-field" aria-hidden="true">
      <label>
        Leave this field empty
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}

export function useGuard() {
  const startedAt = useRef(Date.now());
  const [honeypot, setHoneypot] = useState("");
  return { startedAt: startedAt.current, honeypot, setHoneypot };
}

export async function submitForm(url, payload) {
  try {
    const { data } = await api.post(url, payload);
    return { ok: true, message: data.message };
  } catch (e) {
    return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
  }
}
